import moment from 'moment'
import dayjs from 'dayjs'
export const get_all_months = (locale = 'ja-JP'): Array<any> => {
  moment.locale(locale)
  return moment.monthsShort() || []
}
// Convert a string time to display in correct format: Example "10:09:03.345678" to "10:09:03"
export const timeToString = (timeStr: string, format = 'HH:mm:ss'): string => {
  if (!timeStr) return ''
  const parsedTime = dayjs(`2024-01-01 ${timeStr}`, {
    format: 'YYYY-MM-DD HH:mm:ss.SSSSSS'
  }) // parse a valid date with time string to dayjs object
  return parsedTime.format('HH:mm:ss')
}

// 基準日の1ヶ月前を YYYY-MM-DD 形式で返す（日付フィルタの初期値用）
export const getPreviousMonthDate = (dateString: string): string => {
  return dayjs(dateString).subtract(1, 'month').format('YYYY-MM-DD')
}

// タイムスタンプを YYYY/MM/DD HH:mm 形式にフォーマットする
export const formatTs = (v: string | Date | null | undefined): string => {
  if (!v) return ''
  const d = new Date(v)
  if (Number.isNaN(d.getTime())) return String(v)
  return `${d.getFullYear()}/${String(d.getMonth() + 1).padStart(
    2,
    '0'
  )}/${String(d.getDate()).padStart(2, '0')} ${String(d.getHours()).padStart(
    2,
    '0'
  )}:${String(d.getMinutes()).padStart(2, '0')}`
}
